import React from "react";
import * as styles from "./CustomPromoBanner.module.scss";
import { Button, DiscountChip } from "@silversea-ssc/ui-components-react";
import { Trans } from "@lingui/react/macro";

type Props = {
  isVisible: boolean;
  onClick?: () => void;
};

const CustomPromoBanner: React.FC<Props> = ({ isVisible, onClick }) => {
  if (!isVisible) {
    return null;
  }

  return (
    <Button
      renderAs="div"
      dataContentPiece="customPromo_banner"
      className={styles.headerContainer}
      onClick={onClick}
      size="small"
    >
      <DiscountChip
        lineThrough={false}
        background="transparent"
        className={styles.discountChip}
      >
        <Trans>$100 SHIPBOARD CREDIT OFFER - VALID UNTIL AUGUST 31</Trans>
      </DiscountChip>
    </Button>
  );
};

export default CustomPromoBanner;
